<template>
  <div class="main-body margin_bottom" style="color: white">
    <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
    <div class="container" v-if="ChannelData">
      <div class="row">
        <div class="col-12 col-md-3 mb-3 mb-md-0">
          <div class="book_font_cover">
            <img :src="ChannelData.image_url" class="img-fluid" />
          </div>
        </div>
        <div class="col-12 col-md-9">
          <h2 class="book_title"></h2>

          <div class="d-flex flex-column flex-md-row gap-0 gap-md-4">
            <p class="book_author mb-1">
              <strong class="me-2">Name:</strong> {{ ChannelData.name }}
            </p>
          </div>
          <div>
            <p class="audio_artis mb-1">
              <strong class="me-2">Percentage : </strong>
              {{ ChannelData.percentage }}%
            </p>
            <p class="audio_artis mb-1">
              <strong class="me-2">Kabbik Percentage : </strong>
              {{ kabbikPercentage }}%
            </p>
          </div>
          <div class="mt-3">
            <button
              class="btn btn-primary btn-sm"
              data-bs-toggle="modal"
              data-bs-target="#UpdateChannelModal"
            >
              Edit Channel
            </button>
            <button class="btn btn-danger btn-sm m-1">Block Channel</button>
          </div>
        </div>
        <update-channel-modal
          :channel_id="channelId"
          :channel_name="ChannelData.name"
          :channel_img="ChannelData.image_url"
          :reloadChannel = "getChannelData"
        ></update-channel-modal>
      </div>
      <h3 class="text-white mt-5">Audio Book List</h3>
      <hr class="bg-white" />
      <div class="container">
        <div class="row">
          <div
            class="col-12 col-md-2 col-lg-2 mb-3"
            v-for="(data, index) in AudiobookData"
            :key="index"
          >
            <div
              class="card bg-dark bg-transparent"
              v-on:click="navigate(data.id)"
              style="cursor: pointer"
            >
              <img
                class="card-img-top"
                :src="data.thumb_path"
                alt="Card image cap"
              />
              <div class="mt-2">
                <h5 class="card-title" style=" font-size: 15px">{{ data.name }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="mx-auto responsive"
      style="width: 400px; margin-top: 10px"
    >
      <div class="alert alert-success" role="alert">
        <h4 class="alert-heading">No Data Found!</h4>
        <p>
          Either this Channel is not created or there is no data related to this
          channel.
        </p>
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import UpdateChannelModal from "./UpdateChannelModal";
export default {
  name: "PublisherChannel",
  components: { Loading, UpdateChannelModal },
  data() {
    return {
      id: this.$route.params.id,
      ChannelData: [],
      AudiobookData: [],
      kabbikPercentage: null,
      channelId: null,
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars",
    };
  },
  methods: {
    navigate(id) {
      console.log(id);
      this.$router.push("/audiobook/" + id);
    },
    async getChannelData() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/channels/admin/get-by-publisher" +
            "?publisher_id=" +
            this.id,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          this.ChannelData = res.data[0];
          this.channelId = this.ChannelData.id;
          this.kabbikPercentage = 100 - this.ChannelData.percentage;
          this.getAudioBookData(this.channelId);
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async getAudioBookData(id) {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/audiobooks/all-by-channel-id" +
            "?channel_id=" +
            id,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          this.AudiobookData = res.data;
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.getChannelData();
  },
};
</script>
<style scoped>
@import "../../assets/css/channel.scss";
</style>
